import React from 'react'
import './Malaria.css'
import CountUp from 'react-countup';
import {Context as CasesContext} from '../Context/CasesContext'
import { useContext } from 'react';


const Malaria = () => {
    const {state} = useContext(CasesContext)

    if(!state.malaria){
        return (
          <div style={{height:'100vh', width:'100%'}} >
            {/* <div className="loader">Loading...</div> */}
            <h1 style={{color:'#fff'}} >No data available</h1>
          </div>
        )
      }

    return (
        <div className='Malaria' >
                    <div className='Global-report margin-up' >
                    <p className='Global-report-text'>Malaria summary:</p>
                    <p className='Global-report-text'>Total: <span style={{color:'#1596A7'}} > <CountUp start={0} separator=',' end={state.malaria.total || 0 } /> </span>  </p>
                    <p className='Global-report-text'>Deaths: <span style={{color:'#C85C75'}} ><CountUp start={0} separator=',' end={state.malaria.deaths || 0} /></span></p>
                    <p className='Global-report-text'>Recovered: <span style={{color:'#6BBF95'}} ><CountUp start={0} separator=',' end={state.malaria.recovered || 0} /></span></p>
                    <p className='Global-report-text'>Active: <span style={{color:'#6BBF95'}} ><CountUp start={0} separator=',' end={state.malaria.active || 0} /></span></p>
                    </div>
        </div>
    )
}

export default Malaria
